const SouthAfricaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112398)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.85785 34.1418C-1.95262 26.3312 -1.95262 13.668 5.85785 5.85742C5.8573 5.85828 17.3914 19.9996 17.3914 19.9996L5.85785 34.1418Z"
        fill="black"
      />
      <path
        d="M17.3912 20.0009L2.65246 10.041C2.19551 10.8353 1.79254 11.6644 1.44629 12.5225L8.90793 20.001L1.44652 27.4799C1.79246 28.3374 2.19504 29.1659 2.65168 29.9597L17.3912 20.0009Z"
        fill="#FFDA44"
      />
      <path
        d="M39.8308 17.3906H17.3908L5.85771 5.85742C4.6149 7.10023 3.53514 8.50578 2.65264 10.0395L12.5932 19.9993L2.65186 29.9579C3.53436 31.492 4.61459 32.898 5.85771 34.1411L17.3908 22.608H39.8308C39.9419 21.7541 40.0001 20.8834 40.0001 19.9993C40.0001 19.1152 39.9419 18.2445 39.8308 17.3906Z"
        fill="#6DA544"
      />
      <path
        d="M7.82324 35.8648C11.1958 38.4571 15.4175 39.9994 20 39.9994C29.2405 39.9994 37.016 33.7321 39.311 25.2168H18.4713L7.82324 35.8648Z"
        fill="#0052B4"
      />
      <path
        d="M39.311 14.7826C37.016 6.26727 29.2405 0 20 0C15.4175 0 11.1958 1.54227 7.82324 4.13461L18.4712 14.7826H39.311Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112398">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SouthAfricaSvg;
